import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const [storyExpanded, setStoryExpanded] = useState(false);
  return <section className="bg-gradient-section px-4 py-12 md:px-8 md:py-16" data-id="element-249" data-mp="38vkhsl9y3zyf">
      <div className="mx-auto max-w-3xl space-y-14" data-id="element-250" data-mp="2uxm2ndnsvzhv">

        {/* Eyebrow */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center text-[12px] font-semibold uppercase tracking-[0.28em] text-[#C8A870] md:text-[13px]" data-id="element-251" data-mp="2yypm0a524dnu">
          Una historia que podría ser la tuya
        </motion.p>

        {/* Story Block */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="card-premium relative overflow-hidden p-6 md:p-10" data-id="element-252" data-mp="229zz25ekouv0">
          {/* Línea lateral */}
          <div className="absolute bottom-0 left-0 top-0 w-[2px] bg-gradient-to-b from-transparent via-gold/60 to-transparent" data-id="element-253" data-mp="5dq44e2r1mdt" />

          <div className="pl-3 md:pl-6" data-id="element-254" data-mp="38w9ner3g9hwh">

            {/* Historia colapsable */}
            <div className={`relative overflow-hidden transition-[max-height] duration-500 ease-out ${storyExpanded ? 'max-h-[1400px]' : 'max-h-[330px]'}`} data-id="element-255" data-mp="38u6rxrjj2wkd">
              <div className="space-y-5 md:space-y-6" data-id="element-256" data-mp="3duudvyswgn7q">

                {/* Inicio */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/80 md:text-[20px]" data-id="element-257" data-mp="2q502llo8b6pl">
                  María Elena tenía 49 años. Comía bien, caminaba, dormía
                  temprano.
                </p>

                {/* Situación */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/80 md:text-[20px]" data-id="element-258" data-mp="u2wwd3bumtb0">
                  Pero algo ya no era igual. Su cintura cambió. Se despertaba
                  cansada. Y había días en los que no terminaba de sentirse
                  ella misma.
                </p>

                {/* Insight */}
                <p className="pt-1 font-body text-[17px] font-medium italic leading-[1.6] text-[#F0E8D8] md:text-[19px]" data-id="element-259" data-mp="669dd6un78x7">
                  Durante mucho tiempo creyó que necesitaba esforzarse más.
                  Hasta que entendió algo: no estaba fallando; estaba
                  atravesando una etapa diferente.
                </p>

                {/* Nueva interpretación */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/75 md:text-[19px]" data-id="element-260" data-mp="1qjrlqe44hh6e">
                  Lo que antes funcionaba no era necesariamente lo que más
                  necesitaba ahora. Su cuerpo le estaba dando nuevas señales,
                  y aprender a reconocerlas era el primer paso para acompañar
                  esa etapa de otra manera.
                </p>

                {/* Divider */}
                <div className="divider-fine !mt-7 w-full" data-id="element-261" data-mp="1vvx04077r4fj" />

                {/* H.E.R. */}
                <p className="font-body text-[16px] font-semibold text-[#C8A870] md:text-[17px]" data-id="element-262" data-mp="1rw63hfv09u33">
                  Por eso necesitaba algo diferente: una forma de acompañar
                  esta etapa sin exigirse más.
                </p>

                <p className="font-body text-[16px] font-semibold text-[#C8A870] md:text-[17px]" data-id="element-263" data-mp="1cyvr84ajgk6b">
                  Eso es lo que propone H.E.R.
                </p>
              </div>

              {/* Fade */}
              {!storyExpanded && <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#120f0d] via-[#120f0d]/90 to-transparent" data-id="element-264" data-mp="37cn194ws562a" />}
            </div>

            {/* Toggle */}
            <div className="mt-5 flex justify-center" data-id="element-265" data-mp="3acosuod8191u">
              <button type="button" onClick={() => setStoryExpanded(value => !value)} aria-expanded={storyExpanded} className="inline-flex items-center gap-2 font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-[#C8A870] transition-opacity duration-300 hover:opacity-70" data-id="element-266" data-mp="3fe4fulyylpmv">
                <span data-id="element-267" data-mp="2wg1uqi9j8cuc">
                  {storyExpanded ? 'Ocultar historia' : 'Leer la historia completa'}
                </span>

                <span className={`transition-transform duration-300 ${storyExpanded ? 'rotate-180' : ''}`} data-id="element-268" data-mp="2moxezgc18nyg">
                  ↓
                </span>
              </button>
            </div>
          </div>
        </motion.div>

      </div>
    </section>;
}